export type ProcessSortOrder = 'asc' | 'desc';
export type ProcessSortField = 'updated_at' | 'last_status_update_at';

export const DEFAULT_PROCESS_SORT_ORDER: ProcessSortOrder = 'desc';
export const PROCESS_SORT_FIELD = 'updated_at';
export const PROCESS_STATUS_UPDATE_SORT_FIELD = 'last_status_update_at';

export function getProcessSortQueryParams(
  sortOrder: ProcessSortOrder = DEFAULT_PROCESS_SORT_ORDER,
  sortBy: ProcessSortField = PROCESS_SORT_FIELD
) {
  return {
    sortBy,
    sortOrder,
  };
}

export function processSortOrderLabel(sortOrder: ProcessSortOrder): string {
  return sortOrder === 'desc' ? 'Mais recentes' : 'Mais antigos';
}
